export const isAndroid = () => /Android/i.test(navigator.userAgent)

// Android WebViews ignore <a download> on blob URLs, so the PDF is shared or opened instead
export const deliverPdfOnAndroid = async (blob, url, fileName) => {
    try {
        const file = new File([blob], fileName, { type: 'application/pdf' })
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
            await navigator.share({ files: [file], title: fileName })
            return
        }
    } catch (error) {
        if (error && error.name === 'AbortError') return
    }

    const opened = window.open(url, '_blank')
    if (!opened) window.location.assign(url)
}
